// extracted by mini-css-extract-plugin
export var anchor = "_5e-0";
export var discard = "_5e-4";
export var muiTooltipTooltip = "_5e-6";
export var notificationBar = "_5e-3";
export var saveButtonHoverSlotWrapper = "_5e-5";
export var show = "_5e-2";
export var spacer = "_5e-1";